import { ChargeInterface, OrderOptionsInterface } from "@/interface/business/order.interface";
import { ChargeType, OrderOptionType } from "@/types/orders";
import { Charge } from "@/modules/location";
import { ORDER_OPTION_TYPE } from "@/enums/orders.enum";

export default class OrderOption implements OrderOptionsInterface {
  id: string = "";
  name: string = "";
  type: string = ORDER_OPTION_TYPE.OTHER;
  charges?: Array<ChargeInterface>;

  constructor(data: OrderOptionType) {
    if (data) {
      Object.assign(this, data);
      this.charges = data?.charges?.map((charge: ChargeType): ChargeInterface => new Charge(charge));
    }
  }
}
